import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {DocumentSummaryModel} from '../../../../../document/common/api/model/documentSummary.model';
import {BaseAuditableDto} from '../../../../../../shared/model/core/baseAuditableDto.model';
import {IWithPermissionModel} from '../../../../../common/permission/api/entity/iWithPermission.model';
import {Moment} from 'moment';

export class SaleInvoiceSummaryModel extends BaseAuditableDto implements IWithPermissionModel {
    id: number;
    status: LovValueSummary;
    date: Moment;
    number: string;
    document: DocumentSummaryModel;
    logKey: string;
    saleId: number;
}
export enum SaleInvoiceStatus {
    SALE_INVOICE_STATUS_CREATED = 'SALE_INVOICE_STATUS_CREATED',
    SALE_INVOICE_STATUS_SENT = 'SALE_INVOICE_STATUS_SENT'
}
